import { compose } from 'redux'

export interface ITranslateFn {
  (value: string): string
}

export const safeTranslations = (key: string, translateFn: ITranslateFn) => {
  try {
    return compose(decodeURI, translateFn)(key)
  } catch {
    return key
  }
}
